require("prismjs/themes/prism.css")
const React = require("react")
const { default: DocSidebarPersistent } = require("./src/components/DocSidebarPersistent")
const { default: DocHeaderPersistent } = require("./src/components/DocHeaderPersistent")
const { default: KBarProvider } = require("./src/components/KBarProvider")

// Note: The Script Adds CLUTCHCO property to DOM Window object
const injectClutchScript = () => {
  const script = document.createElement("script")
  script.type = `text/javascript`
  script.src = "https://widget.clutch.co/static/js/widget.js"
  script.async = true
  document.getElementsByTagName(`head`)[0].appendChild(script)
}
exports.onClientEntry = () => {
  injectClutchScript()
}

// Wrap root element with KBar provider for command palette
exports.wrapRootElement = ({ element }) =>
  React.createElement(KBarProvider, null, element)

// Wrap page element to persist sidebar and header across doc pages
exports.wrapPageElement = ({ element, props }) => {
  // Check if this is a doc page by checking pageContext
  const isDocPage = props.pageContext?.repoName !== undefined

  if (isDocPage) {
    // First wrap with header persistence (mobile menu)
    const withPersistentHeader = React.createElement(
      DocHeaderPersistent,
      {
        repoName: props.pageContext.repoName,
        repoDisplayName: props.pageContext.repoDisplayName,
        mdxName: props.pageContext.mdxName,
        currentSlug: props.pageContext.slug,
        categories: props.pageContext.categories,
        location: props.location,
        articles: props.data?.articles
      },
      element
    )

    // Then wrap with sidebar persistence (desktop)
    return React.createElement(
      DocSidebarPersistent,
      {
        repoName: props.pageContext.repoName,
        mdxName: props.pageContext.mdxName,
        currentSlug: props.pageContext.slug,
        categories: props.pageContext.categories,
        location: props.location,
        articles: props.data?.articles
      },
      withPersistentHeader
    )
  }

  return element
}
